import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { homePath } from "@/lib/accountAccess";
import api, { apiError } from "@/lib/api";

export default function FirstPasswordChange() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async event => {
    event.preventDefault(); setError("");
    if (password !== confirm) { setError("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: password });
      localStorage.removeItem("token");
      await logout();
      navigate("/login", { replace: true });
    } catch (e) { setError(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (loading) return <p className="p-8 text-navy">Loading…</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to={homePath(user)} replace />;
  return <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6"><form onSubmit={submit} className="w-full max-w-md bg-white border rounded-xl p-6 space-y-5">
    <h1 className="font-heading text-2xl font-bold text-navy">Set your own password</h1>
    <p className="text-sm text-slate-500">Welcome, {user.name || user.username}. Change the temporary password issued by Akash before opening your business. You will then sign in with your new password.</p>
    <div><Label htmlFor="temporary-password">Current temporary password</Label><Input id="temporary-password" required type="password" autoComplete="current-password" value={current} onChange={e => setCurrent(e.target.value)} /></div>
    <div><Label htmlFor="first-new-password">New password</Label><Input id="first-new-password" required minLength={10} type="password" autoComplete="new-password" value={password} onChange={e => setPassword(e.target.value)} /><p className="text-xs text-slate-500 mt-1">At least 10 characters, different from your temporary password.</p></div>
    <div><Label htmlFor="first-confirm-password">Confirm new password</Label><Input id="first-confirm-password" required type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} /></div>
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    <Button type="submit" disabled={busy} className="w-full bg-maroon hover:bg-maroon-hover">{busy ? "Saving…" : "Save Password & Sign In"}</Button>
    <button type="button" disabled={busy} onClick={async () => { await logout(); navigate("/login", { replace: true }); }} className="text-sm text-slate-500 w-full">Sign out</button>
  </form></div>;
}
